// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3i_HCbGWfA20zzthE_a4eZ","item":"_3oDDc1weXUjmAiAkb2iNk","label":"_4dlXIANPuhE39WGwqgFfH","image":"_1y-XGFb-kJnrrl5MVecgvt","important":"_2GBXv-GqaF3hWFlj1my9Ak"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/NavigationBar/components/AccountMenuItem/styles.scss
// module id = 617
// module chunks = 11